import { Link } from 'react-router-dom';
import { MAIN_PHONE_DISPLAY, MAIN_PHONE_TEL } from '../../constants/contact';
import usePageMeta from '../../utils/usePageMeta';
import {
  ADDRESS_COUNTRY,
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_EMAIL,
  COMPANY_NAME,
  POLICY_LINKS,
  POLICY_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
} from '../../constants/site';
import SiteLayout from './SiteLayout';

export function Section({ title, children }) {
  return (
    <section className="fx-policy__section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}

export function List({ items }) {
  return (
    <ul>
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}

export function ContactBlock() {
  return (
    <div className="fx-policy__contact">
      <p>
        <strong>{COMPANY_NAME}</strong> (operator of {SITE_NAME}, {SITE_DOMAIN})
        <br />
        {ADDRESS_LINE1}, {ADDRESS_LINE2}, {ADDRESS_COUNTRY}
        <br />
        Email: <a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a>
        <br />
        Phone: <a href={`tel:${MAIN_PHONE_TEL}`}>{MAIN_PHONE_DISPLAY}</a>
      </p>
    </div>
  );
}

/**
 * Shared shell for About, Contact and every policy page.
 * `meta` comes from pageMeta(); `intro` is the lead paragraph under the title.
 */
export default function PolicyPage({ title, intro, meta, showUpdated = true, showRelated = true, children }) {
  usePageMeta(meta);

  return (
    <SiteLayout>
      <div className="fx-pagehead">
        <div className="fx-wrap">
          <p className="fx-crumbs">
            <Link to="/">Home</Link> <span aria-hidden>/</span> {title}
          </p>
          <h1>{title}</h1>
          {intro && <p className="fx-pagehead__lead">{intro}</p>}
          {showUpdated && <p className="fx-pagehead__date">Last updated: {POLICY_UPDATED}</p>}
        </div>
      </div>
      <div className="fx-wrap fx-policy">
        <article className="fx-policy__body">{children}</article>
        {showRelated && (
          <aside className="fx-policy__aside" aria-label="Other policies">
            <h2>Our policies</h2>
            {POLICY_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className={l.label === title ? 'is-current' : undefined}>
                {l.label}
              </Link>
            ))}
          </aside>
        )}
      </div>
    </SiteLayout>
  );
}
